import React from 'react'
import ClipLoader from "react-spinners/ClipLoader";

const Loader = ({loading}) => {
   
    return (
        <div className="loader">
            {/* <DotLoader color="#FF9156" /> */}
            <ClipLoader color="#FF9156" />
        </div>
    )

}
export default Loader